/* eslint-disable @typescript-eslint/no-explicit-any */
import HeadingElement from '../HeadingElement';
import ContentElement from '../ContentElement';
import TextInputElement from '../TextInputElement';
import BooleanElement from '../BooleanElement';
import MultichoiceElement from '../MultichoiceElement';
import MarketSelectorElement from '../MarketSelectorElement';
import FileUploadElement from '../FileUploadElement';
import LocationInputElement from '../LocationInputElement';
import AddonElement from '../AddonElement';

let form = {
  HeadingElement,
  ContentElement,
  TextElement: TextInputElement,
  BooleanElement,
  MarketSelectorElement,
  MultichoiceElement,
  FileUploadElement,
  LocationInput: LocationInputElement,
  AddonElement: AddonElement,
};

type ClassMap = typeof form;
type InstanceMap = { [K in keyof ClassMap]: InstanceType<ClassMap[K]> };

export default function createFormElement<K extends keyof InstanceMap>(
  id: string,
  type: K,
  fieldDef?: ObjectOf<any> | null | undefined,
): InstanceMap[K] | undefined {
  let Element = form[type];
  return Element ? (new Element(id, fieldDef as any) as any) : undefined;
}
